<div class="card">
    <div class="heading">

        <span class="pi pi-user"></span>&nbsp;
        <h3 id="h3">Select Doctor </h3>

    </div>
    <p-table [columns]="cols" [value]="multirecord" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5,10,15,20]"
        totalRecords="totalRecords" pageLinks="3" [loading]="loading" [autoLayout]="true">

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    <b>{{col.header}}</b>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    <ng-container *ngIf="col.field === 'check'">
                        <button type="button" pButton pRipple icon="pi pi-search"
                            (click)="selectDoctor(rowData)"></button>
                    </ng-container>
                    {{rowData[col.field]}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            <p-button icon="pi pi-chevron-circle-left" (click)="prev()"></p-button>
        </ng-template>
    </p-table>
</div>
